<template>
	<div class="about-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner" id="pingtaijieshao">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">平台介绍</div>
				<div class="des">Platform Introduction</div>
			</div>
		</div>
		<!-- 简介 -->
		<div class="jianjie wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="jianjie-container w1260">
				<div class="heading">中国集装箱行业绿色低碳公共服务平台</div>
				<div class="des">
					{{ webInfo.pingtaijieshao }}
				</div>
			</div>
		</div>
		<!-- 四个统一 -->
		<div class="tongyi wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="tongyi-container w1260">
				<div class="heading">平台助力行业绿色发展实现“四个统一”</div>
				<div class="list">
					<div class="item">
						<div class="icon">
							<svg-icon name="tongyi-1"></svg-icon>
						</div>
						<div class="label">产品碳足迹核算模型统一</div>
					</div>
					<div class="item">
						<div class="icon">
							<svg-icon name="tongyi-2"></svg-icon>
						</div>
						<div class="label">碳排放因子库统一</div>
					</div>
					<div class="item">
						<div class="icon">
							<svg-icon name="tongyi-3"></svg-icon>
						</div>
						<div class="label">产品碳标签统一</div>
					</div>
					<div class="item">
						<div class="icon">
							<svg-icon name="tongyi-4"></svg-icon>
						</div>
						<div class="label">绿色产品评价体系统一</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 四大服务 -->
		<div class="sidafuwu wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="heading">四大服务</div>
			<div class="list">
				<div class="item" v-for="(item,index) in webInfo.sidafuwu">
					<div class="card">
						<div class="icon">
							<svg-icon :name="item.icon"></svg-icon>
						</div>
						<div class="title">{{item.title}}</div>
						<div class="des">{{item.des}}</div>
						<div class="more">
							<div class="text">了解更多</div>
							<svg-icon name="jiantou4"></svg-icon>
						</div>
					</div>
					<router-link tag="div" class="active-card" :to="{ name: item.name }">
						<div class="icon">
							<svg-icon :name="item.iconActive"></svg-icon>
						</div>
						<div class="title">{{item.title}}</div>
						<div class="des">{{item.des}}</div>
						<div class="more">
							<div class="text">了解更多</div>
							<svg-icon name="jiantou4"></svg-icon>
						</div>
					</router-link>
				</div>
			</div>
		</div>
		<!-- 平台资质 -->
		<div v-if="false" class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="zizhi">
				<div class="zizhi-container w1260">
					<div class="heading">平台资质</div>
					<div class="swiper swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide item" v-for="(item, index) in swiperList">
								<!-- <img class="img" :src="item.imageUrl" alt="" /> -->
								<el-image
								    class="img"
								    :src="item.imageUrl" 
								    :preview-src-list="[item.imageUrl]">
								  </el-image>
								<div class="des ellipsis-3">{{ item.title }}</div>
							</div>
						</div>
					</div>
					<div class="swiper-btns">
						<div class="prev" :class="{ end: virtualIndex <= perViewNum }" @click="slidePrev">
							<svg-icon name="arrow5"></svg-icon>
						</div>
						<div class="next" :class="{ end: virtualIndex >= swiperList.length }" @click="slideNext">
							<svg-icon name="arrow6"></svg-icon>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 联系我们 -->
		<!-- <div class="lianxiwomen" id="lianxiwomen">
			<div class="heading">联系我们</div>
			<div class="form">
				<div class="name">
					<el-input v-model="name" placeholder="姓名"></el-input>
				</div>
				<div class="phone">
					<el-input v-model="phone" placeholder="电话"></el-input>
				</div>
				<div class="shixiang">
					<el-input v-model="cooperationItem" placeholder="合作事项"></el-input>
				</div>
			</div>
			<div class="btns">
				<el-button class="submit" type="whitetrans" @click="submit">提交</el-button>
			</div>
		</div> -->
		<Foot></Foot>
	</div>
</template>

<script>
import { AddContactUs, PlatformQualification } from '@/common/api.js';
import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css'; // 注意这里的引入
export default {
	components: { Head, Foot },
	data() {
		return {
			value: '',
			qualificationList: [],
			// swiper实例  实例上有各种方法
			swiperInstance: null,
			swiperList: [],
			// swiperList: [{},{},{},{},{},{},{},{},{},{},{},{},],
			virtualIndex: 4,
			perViewNum: 4,
			name: '', // 姓名
			phone: '', // 电话
			cooperationItem: '', // 合作事项
			// 网站信息
			webInfo: webInfo
		};
	},
	created() {
		this.getPlatformQualification();
	},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		// 提交联系我们
		submit() {
			if (!this.name) {
				return this.toast('请填写姓名');
			}
			if (!this.phone) {
				return this.toast('请填写电话');
			} else {
				let result = this.verifyVal({ val: this.phone, rules: ['phone'] });
				if (!result.valid) {
					return this.toast('手机号格式不正确');
				}
			}
			if (!this.cooperationItem) {
				return this.toast('请填写合作事项');
			}
			let data = {
				name: this.name,
				phone: this.phone,
				cooperationItem: this.cooperationItem
			};
			AddContactUs(data).then((res) => {
				this.toast({
					type: 'success',
					message: '提交成功'
				});
			});
		},
		// 初始化轮播图
		initSwiper() {
			let _that = this;
			this.swiperInstance = new Swiper('.swiper-container', {
				// config...
				//根据slider的宽度自动分布
				loop: false,
				slidesPerView: 'auto',
				on: {
					slideChange: function (e) {
						console.log('this.realIndex: ', this.realIndex);
						_that.virtualIndex = this.realIndex + _that.perViewNum;
						console.log('_that.virtualIndex: ', _that.virtualIndex);
					}
				}
			});
		},
		slidePrev() {
			if (this.virtualIndex > this.perViewNum) {
				// this.swiperInstance.slidePrev()
				this.virtualIndex--;
				this.swiperInstance.slideTo(this.virtualIndex - this.perViewNum);
				console.log('this.virtualIndex: ', this.virtualIndex);
			}
		},
		slideNext() {
			if (this.virtualIndex < this.swiperList.length) {
				// this.swiperInstance.slideNext()
				this.virtualIndex++;
				this.swiperInstance.slideTo(this.virtualIndex - this.perViewNum);
				console.log('this.virtualIndex: ', this.virtualIndex);
			}
		},
		// 获取平台资质列表
		getPlatformQualification() {
			PlatformQualification().then((res) => {
				this.swiperList = res.data;
				this.$nextTick(() => {
					this.initSwiper();
				});
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.about-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/032.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			.heading {
				margin-top: 121px;
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: normal;
				font-size: 53px;
				color: #ffffff;
				line-height: 60px;
				text-align: center;
			}
			.des {
				margin-top: 21px;
				font-family: Arial, Arial;
				font-weight: 900;
				font-size: 23px;
				color: #ffffff;
				line-height: 32px;
				text-align: center;
			}
		}
	}

	.jianjie {
		padding-top: 49px;
		padding-bottom: 75px;
		background: #f9fafb;
		.jianjie-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
				text-align: center;
			}
			.des {
				margin-top: 22px;
				width: 1200px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: rgba(#262729, 0.7);
				line-height: 30px;
				text-align: justify;
				text-align-last: center;
			}
		}
	}
	
	.tongyi {
		padding-top: 49px;
		padding-bottom: 75px;
		background: #FFFFFF;
		.tongyi-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
				text-align: center;
			}
			.list {
				align-self: stretch;
				margin-top: 100px;
				display: flex;
				justify-content: space-between;
				.item {
					display: flex;
					flex-direction: column;
					align-items: center;
					.icon {
						display: flex;
						.svg-icon {
							width: 70px;
							height: 70px;
						}
					}
					.label {
						margin-top: 27px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
					}
				}
			}
		}
	}

	.sidafuwu {
		padding-top: 41px;
		// padding-bottom: 35px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		.heading {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 28px;
			color: #000000;
			line-height: 52px;
			text-align: center;
		}
		.list {
			margin-top: 49px;
			display: flex;
			.item {
				width: 25%;
				display: flex;
				transition: all 0.3s ease;
				&:nth-child(odd) {
					.card {
						background: #ffffff;
					}
				}
				&:nth-child(even) {
					.card {
						background: #f6f6f6;
					}
				}
				&:hover {
					width: 33%;
					flex-shrink: 0;
					.card {
						display: none;
					}
					.active-card {
						display: flex;
					}
				}
				.card {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					// padding: 0 35px;
					padding-bottom: 25px;
					box-sizing: border-box;
					cursor: default;
					.icon {
						height: 92px;
						display: flex;
						flex-direction: column;
						align-items: center;
						.svg-bar {
							margin-top: 42px;
							width: 31px;
							height: 31px;
						}
						.svg-renzheng {
							margin-top: 42px;
							width: 33px;
							height: 33px;
						}
						.svg-yun {
							margin-top: 40px;
							width: 33px;
							height: 35px;
						}
						.svg-shuye3 {
							margin-top: 42px;
							width: 31px;
							height: 33px;
						}
					}
					.title {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 18px;
						color: #000000;
						line-height: 25px;
					}
					.des {
						width: 264px;
						margin-top: 16px;
						min-height: 55px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #9f9f9f;
						line-height: 17px;
						text-align: justify;
						text-align-last: center;
					}
					.more {
						margin-top: 10px;
						padding: 15px;
						display: flex;
						align-items: center;
						.text {
							margin-right: 4px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 12px;
							color: #29965c;
							line-height: 17px;
						}
						.svg-jiantou4 {
							width: 12px;
							height: 9px;
							stroke: #29965c;
						}
					}
				}
				.active-card {
					width: 100%;
					display: none;
					background: #29965c;
					flex-direction: column;
					padding-left: 89px;
					// padding-right: 54px;
					padding-bottom: 25px;
					box-sizing: border-box;
					position: relative;
					cursor: pointer;
					.icon {
						position: absolute;
						top: 0;
						right: 0;
						padding-top: 30px;
						padding-right: 30px;
						.svg-bar2 {
							width: 49px;
							height: 50px;
						}
						.svg-renzheng2 {
							width: 52px;
							height: 52px;
						}
						.svg-yun2 {
							width: 55px;
							height: 59px;
						}
						.svg-shuye4 {
							width: 49px;
							height: 53px;
						}
					}
					.title {
						margin-top: 69px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 18px;
						color: #f1fff7;
						line-height: 23px;
					}
					.des {
						margin-top: 15px;
						width: 331px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: rgba(#ffffff, 0.83);
						line-height: 18px;
					}
					.more {
						margin-top: 18px;
						padding: 15px 15px 15px 0;
						display: flex;
						align-items: center;
						.text {
							margin-right: 4px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 12px;
							color: #ffffff;
							line-height: 17px;
						}
						.svg-jiantou4 {
							width: 12px;
							height: 9px;
							stroke: #ffffff;
						}
					}
				}
			}
		}
	}

	.zizhi {
		padding-top: 41px;
		padding-bottom: 50px;
		min-height: calc(52px + 37px + 366px + 28px + 40px + 28px);
		.zizhi-container {
			display: flex;
			flex-direction: column;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 34px;
				color: #000000;
				line-height: 52px;
				text-align: center;
			}
			.swiper {
				margin-top: 37px;
				width: 100%;
				padding: 20px 0;
				.swiper-wrapper {
					width: 100%;
					display: flex;
					margin-left: calc((100% - (257px * 4)) / 6 * -1);
					.item {
						width: 257px;
						height: calc(366px + 28px + 40px + 28px);
						margin: 0 calc((100% - (257px * 4)) / 6);
						&:hover {
							.img {
								transform: scale(1.05);
							}
						}
						.img {
							transition: all 0.3s ease;
							width: 100%;
							height: 366px;
							object-fit: fill;
						}
						.des {
							margin-top: 28px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 14px;
							color: #000000;
							line-height: 20px;
							text-align: center;
						}
					}
				}
			}
			.swiper-btns {
				margin-top: 20px;
				display: flex;
				justify-content: center;
				.prev {
					padding: 15px;
					cursor: pointer;
					&:hover {
						.svg-icon {
							stroke: $primary;
						}
					}
					&.end {
						.svg-icon {
							stroke: #a5a9b1;
						}
					}
					.svg-icon {
						width: 20px;
						height: 15px;
						stroke: #666;
					}
				}
				.next {
					padding: 15px;
					cursor: pointer;
					&:hover {
						.svg-icon {
							stroke: $primary;
						}
					}
					&.end {
						.svg-icon {
							stroke: #a5a9b1;
						}
					}
					.svg-icon {
						width: 20px;
						height: 15px;
						stroke: #666;
					}
				}
			}
		}
	}
	.lianxiwomen {
		padding-top: 37px;
		padding-left: 90px;
		padding-right: 90px;
		padding-bottom: 49px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #29965c;
		.heading {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 34px;
			color: #ffffff;
			line-height: 52px;
		}
		.form {
			margin-top: 34px;
			width: 100%;
			display: flex;
			.phone,
			.name {
				margin-right: 20px;
				::v-deep {
					.el-input {
						.el-input__inner {
							width: 253px;
							height: 65px;
							padding-left: 24px;
							padding-right: 24px;
							box-sizing: border-box;
							background: rgba(#ffffff, 0.2);
							border-radius: 0;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 15px;
							color: #ffffff;
							line-height: 21px;
							border-color: #ffffff;
							&:not(:focus) {
								border-color: transparent;
							}
							&::placeholder {
								color: rgba(#ffffff, 0.7);
							}
						}
					}
				}
			}
			.shixiang {
				flex: 1;
				::v-deep {
					.el-input {
						.el-input__inner {
							width: 100%;
							height: 65px;
							padding-left: 24px;
							padding-right: 24px;
							box-sizing: border-box;
							background: rgba(#ffffff, 0.2);
							border-radius: 0;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 15px;
							color: #ffffff;
							line-height: 21px;
							border-color: #ffffff;
							&:not(:focus) {
								border-color: transparent;
							}
							&::placeholder {
								color: rgba(#ffffff, 0.7);
							}
						}
					}
				}
			}
		}
		.btns {
			margin-top: 42px;
			display: flex;
			.submit {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0;
				width: 160px;
				height: 50px;
				border-radius: 0px;
				// font-weight: bold;
				font-size: 16px;
				line-height: 22px;
			}
		}
	}
}
</style>
